var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"advice-bubble d-flex gap-3 align-items-start"},[_c('div',{staticClass:"avatar-container"},[_c('img',{staticClass:"avatar-image",attrs:{"src":_vm.image,"alt":"Advisor"}})]),_c('p',{staticClass:"advice-text"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }